export const useConvertQuillDeltaToPDFRun = (
  ops: any,
  fontSize: number,
  color: string = "#000000",
  includeLineBreaks: boolean = true
) => {
  if (ops == null || ops == undefined) return [];

  const textRunsArray = [];

  let currentTextRuns = [] as any[];
  ops.forEach((op: any) => {
    if (typeof op.insert === "string") {
      // Determine formatting from attributes

      const lines = (op.insert as string).split("\n");

      let index = 0;
      for (const line of lines) {
        const formatting = op.attributes || {};

        const decorations = [];

        if (formatting.underline) {
          decorations.push("underline");
        }

        if (formatting.strike) {
          decorations.push("lineThrough");
        }

        const textRun = {
          text: useRemoveEmojis(line.replace(/[\u200B-\u200D\uFEFF]/g, "")),
          fontSize: fontSize,
          color: color,
          bold: formatting.bold || false,
          italics: formatting.italic || false,
          decoration: decorations.length == 1 ? decorations[0] : decorations,
          lineHeight: 1.5,
        };

        currentTextRuns.push(textRun);

        if (lines.length > 1 && index < lines.length - 1 && includeLineBreaks) {
          currentTextRuns.push({ text: "\n" });
          textRunsArray.push(currentTextRuns);
          currentTextRuns = [];
        }

        index++;
      }
    }

    // if ((op.insert as string).includes("\n") && includeLineBreaks) {
    //   textRunsArray.push(currentTextRuns);
    //   currentTextRuns = [];
    // }
  });

  // Handle any remaining TextRuns
  if (currentTextRuns.length > 0) {
    textRunsArray.push(currentTextRuns);
  }

  return textRunsArray;
};
